import styled from 'styled-components';

export const SelectWrapper = styled.div`
  width: 100%;

  > * {
    width: 100%;
  }

  select {
    line-height: 24px;
    height: 44px;
    padding: 10px 12px 9px 11px;
    box-sizing: border-box;
  }
`;
